import React, { Component } from 'react';
import $ from 'jquery';
import Header from '../components/Header'
import FileTable from '../components/tables/FileTable'
import { connect } from 'react-redux'
import AuthHOC from './Auth'
import { withAlert } from 'react-alert'
import ExportDataRowsModal from '../components/modals/ExportDataRowsModal';
import { Alert } from 'reactstrap';
import { Stack, Typography } from '@mui/material';

class ListView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      numPages: 0,
      pageNumber: 1,
      prevPageLimit: 0,
      pageLimit: 10,
      activeIndex: 0,
      fileCount: 0,
      files: [],
      filesSelected: [],
      fileTypes: [],
      cSelected: [],
      loginModal: true,
      keyid: null,
      exportFilesModalVisible: false,
      associated_children: [],
      toastVisible: false,
      toastText: '',
      toastColor: 'info',
    };

    this.refresh = this.refresh.bind(this);
    this.expandLogs = this.expandLogs.bind(this);
  }

  componentDidMount() {
    this.refresh();
  }

  componentWillUnmount() {
    if (this._toastTimer) clearTimeout(this._toastTimer);
  }

  refresh() {
    if (this.props.search)
      fetch(window.location.protocol + '//' + window.location.host + '/api/archive/search' + this.props.search, {
        method: 'GET'
      })
        .then(res => res.json())
        .then(
          (result) => {
            if (!result.success) {
              //this.props.dispatch(loginError(result.message))
            }
            else {
              this.setState({
                files: result.files,
                keyid: result.keyid
              })
            }
          })
        .catch(error => {
          console.error(error)
        });
  }

  showToast = (text, color = 'info', duration = 4000) => {
    this.setState({ toastVisible: true, toastText: text, toastColor: color });
    if (this._toastTimer) clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => this.setState({ toastVisible: false }), duration);
  };

  hideToast = () => {
    if (this._toastTimer) clearTimeout(this._toastTimer);
    this.setState({ toastVisible: false });
  };

  handleDownloadSelected = async (ids) => {
    if (!ids?.length) return;
    if (ids.length > 250) {
      this.showToast('Download limit reached for a single request.', 'danger', 6000);
      return;
    }
    this.showToast(`Preparing download for ${ids.length} document${ids.length > 1 ? 's' : ''}…`, 'info', 6000);
    this.isLoading(true);
    try {
      const res = await fetch(
        `${window.location.protocol}//${window.location.host}/api/archive/download-batch`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ ids }),
        }
      );
      if (!res.ok) {
        console.error("result not okay: " + JSON.stringify(res));
        const text = await res.text();
        this.showToast(text || 'Download failed.', 'danger', 7000);
        return;
      }
      // zip is ready
      this.showToast('Download starting…', 'success', 3000);

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');

      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_` + `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;

      a.href = url;
      a.download = `documents_${stamp}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

    }
    finally {
      this.isLoading(false);
    }
  }

  isLoading = (loading) => {
    this.setState({
      loading,
    });
  };

  exportButtonPressed = () => {
    this.setState({
      exportFilesModalVisible: !this.state.exportFilesModalVisible
    })
  }

  expandLogs(file) {
    let id = file._id;

    var found = this.state.associated_children.find(element => {
      return element.id == id;
    });

    if (found) {
      this.setState(prevState => ({
        associated_children: prevState.associated_children.filter(j => found !== j)
      }))
    }
    else {
      fetch(window.location.protocol + '//' + window.location.host + '/api/archive/portfolio?_id=' + id + '&getFile=false')
        .then(res => res.json())
        .then(
          (result) => {
            if (!result.empty) {
              this.setState(prevState => ({
                associated_children: prevState.associated_children.concat({
                  id: file._id,
                  associated: result
                })
              }));
            }
          })
        .catch(error => {
          this.props.alert.error('Unable to load portfolio data - ' + error);
        });
    }
  }



  render() {
    const { parsed, localisation } = this.props;
    // X3 mode (paper-clip Document Portfolio inside the Sage X3 frame) enables the
    // selection checkboxes and bulk Download. Decide it from the query string that
    // AuthHOC captured at load, NOT from window.location: by the time this view mounts
    // the Token login has already stripped the whole query string from the address
    // (Auth.js history.replace, #9160) so window.location.href never contains X3=true.
    // Same source as the Header visibility check, so both agree.
    const fileDownloadEnabled = !!(parsed && (parsed.X3 || parsed.x3));
    const columnConfig = {
      expand: false,
      actions: true,
      checkbox: !!fileDownloadEnabled, // only true if enabled
    };

    return (
      <div className="App">
        <Alert
          color={this.state.toastColor}
          isOpen={this.state.toastVisible}
          toggle={this.hideToast}
          fade
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1080,
            width: 'min(90vw, 480px)',
            textAlign: 'center',
            boxShadow: '0 12px 28px rgba(0,0,0,.2)',
            padding: '14px 18px',
            margin: 0,
          }}
        >
          {this.state.toastText}
        </Alert>
        <Header visible={!parsed.X3} />
        <div id="s-site-body" className="page-wrapper">
        <div className="s-page">
          <div className="s-page-header">
            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {localisation['menu_header_document_portfolio'] ? localisation['menu_header_document_portfolio'].element_lang : 'Document Portfolio'}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Browse documents in this portfolio
              </Typography>
            </Stack>
          </div>
          <div className="s-content-panel">
          <FileTable
            add
            viewPortfolio={true}
            DocumentType={parsed.DocumentType}
            refresh={this.refresh}
            DocumentRef={parsed.DocumentRef}
            files={this.state.files}
            keyid={this.state.keyid}
            associated_children={this.state.associated_children}
            expandLogs={this.expandLogs}
            exportRows={this.exportButtonPressed}
            dropzone
            columnConfig={columnConfig}
            onDownloadSelected={this.handleDownloadSelected}
          />
          </div>
        </div>
        </div>
        {this.state.exportFilesModalVisible &&
          <ExportDataRowsModal
            files={this.state.files}
            type={'files'}
            visible={this.state.exportFilesModalVisible}
            toggle={this.exportButtonPressed}
          />
        }
      </div>
    );
  }
}

export default connect(state => state)(AuthHOC(withAlert()(ListView), { name: 'document_porfolio' }));